<template>
    <div class="container">
        <div class="fill" v-if="!finished">
            <div class="title">理赔评价</div>
            <div class="section"><span>*</span>1. 您对本次理赔服务整体满意吗？</div>
            <div class="row-hint">
                <div>非常不满意</div>
                <div>非常满意</div>
            </div>
            <div class="row-units">
                <div v-for="i in 10" :key="i" class="unit" :class="{'unit-active': rate == i}" @click="rate = i">{{ i }}</div>
            </div>
            <div class="section" style="margin-left: 8px; padding-top: 10px;">2. 您的意见和建议（选填）</div>
            <textarea class="input" v-model="remark" maxlength="50" placeholder="请输入，不超过50字"></textarea>
            <div class="btn" @click="submit()">提交</div>
        </div>
        <div class="reback" v-else>
            <img class="banner" src="../shortmsg/assets/images/bannerShort.png" alt="">
            <div class="intro">理赔评价</div>
            <div class="info">
                <img class="icon" src="./assets/images/check_ok.png" alt="">
                <div class="remind">提交成功！</div>
                <div class="tip">感谢您的反馈，我们将持续优化理赔服务！</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: this.$route.params.id,
            rate: '',
            remark: '',
            finished: false,
        }
    },
    mounted() {

    },
    methods: {
        async submit(){
            if(!this.rate){
                this.$toast("请选择满意度");
                return;
            }
            let res = await this.$http.post("/api/claim/externalClaimsScore", {
                reportingNo: this.id,
                score: this.rate,
                evaluate: this.remark,
            });
			if(res.code == 0){
				this.finished = true;
			}else{
				if(res.msg){
					this.$toast.fail(res.msg);
				}
			}
        }
    }
}
</script>

<style lang="scss" scoped>
.container{
	background: #F5F5F5;
	padding-bottom: 30px;
	font-size: 15px;
    color: #000;
	min-height: 100vh;
	box-sizing: border-box;
}
.fill{
    padding: 0 20px;
    .title{
        text-align: center;
        font-size: 17px;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid #c0c0c0;
    }
    .section{
        margin-top: 30px;
        span{
            color: red;
            margin-right: 2px;
        }
    }
    .row-hint{
        margin: 16px auto;
        font-size: 12px;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .row-units{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .unit{
            width: fit-content;
            border: 1px solid #999;
            border-radius: 4px;
            padding: 4px 6px;
            font-size: 13px;
            color: #333;
            background: none;
        }
        .unit-active{
            border: 1px solid #00a971 !important;
            background: #00a971 !important;
            color: white !important;
        }
    }
    .input{
        padding: 8px;
        margin-top: 12px;
        width: 100%;
        height: 80px;
        border: none;
        background: white;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        line-height: 18px;
    }
    .btn{
        margin-top: 30px;
        background: #00a971;
        color: #fff;
        width: 90px;
        height: 35px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 50%;
        transform: translateX(-50%);
        border-radius: 4px;
    }
}
.reback{
    .banner{
        width: 100%;
    }
    .intro{
        margin-top: 30px;
        text-align: center;
        font-size: 19px;
        color: #000;
    }
    .info{
        text-align: center;
        .icon{
            margin-top: 80px;
            width: 30px;
        }
        .remind{
            margin-top: 20px;
            padding-left: 10px;
            font-size: 15px;
            color: #000;
        }
        .tip{
            margin-top: 30px;
            font-size: 12px;
            color: #666;
        }
    }
}
</style>